// extracted by mini-css-extract-plugin
module.exports = {"notificationBlock":"styles_notificationBlock__19LMz"};